import { render, staticRenderFns } from "./HistorySidebar.vue?vue&type=template&id=79b489ba&scoped=true"
import script from "./HistorySidebar.vue?vue&type=script&lang=js"
export * from "./HistorySidebar.vue?vue&type=script&lang=js"
import style0 from "./HistorySidebar.vue?vue&type=style&index=0&id=79b489ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b489ba",
  null
  
)

export default component.exports